import React from 'react'
import { useTranslation } from 'react-i18next';
import ManageState from './manageState';
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import { debouncedApiCall } from '../../../utils/app.utils';
import TableCustom from '../../../components/table/tableCustom';
import StateComponents from '../../../components/state-component/StateComponents';

export default function HistoryOnlineAdmission() {
  const { t } = useTranslation();
  const {
    page,
    pageLimit,
    setPage,
    setPageLimit,
    sortBy,
    sortType,
    handleRequestSort,
    headCells,
    renderData,
    data,
    totalItems,

    setKeyword,
    handleChangeDateRange,
    date_range,
    handleClearDateRange,
  } = ManageState()
  return (
    <div className='w-full'>
      <ContainerLayout
        title={t("Application History")}
        subTitle={'Please select the item you want'}
        // hidden_sub_title
        // navigateContent={
        //     <NavigateListCustom
        //         navigateData={[
        //             {
        //                 key: "complaintSubmit",
        //                 name: t("ตั้งค่า"),
        //                 disabled_match: true,
        //                 pathName: ""
        //             },
        //             {
        //                 key: "complaintSubmit",
        //                 name: t("หมวดหมู่แกลเลอรี"),
        //                 pathName: routeName.cms_website.GalleryTypeManagement
        //             },
        //         ]}
        //     />
        // }
        buttonContent={
          // <ContainerButton
          //     justifyContent='flex-end'
          //     buttonData={[
          //         {
          //             buttonProps: {
          //                 onClick: handleDownloadReport
          //             },
          //             key: "DOWNLOAD_CSV",
          //             label: t("COMPLAINTS_DOWNLOAD_CSV"),
          //             seq: 1,
          //             type: "DOWNLOAD_CSV"
          //         }
          //     ]}
          // />
          <></>
        }
        content={
          <div className='w-full'>

            {/* <StateComponents
              otherProps={{ spacing: 2 }}
              typeProps={[
                {
                  seq: 1,
                  type: "TEXT_FIELD",
                  gridProps: {
                    xs: 12,
                    md: 4
                  },
                  fieldProps: {
                    placeholder: "ค้นหาปีการศึกษา",
                    onChange: (e) => debouncedApiCall({ setItem: setKeyword, searchItem: e.target.value })
                  }
                },

                {
                  type: "COMPONENT",
                  seq: 2,
                  fieldProps: {
                    element: <></>
                  },
                  gridProps: {
                    xs: 12,
                    md: 6
                  }
                },
                // {
                //   seq: 3,
                //   type: "BUTTON",
                //   gridProps: {
                //     xs: 6,
                //     md: 2
                //   },
                //   fieldProps: {
                //     justifyContent: "flex-end",
                //     buttonData: [
                //       {
                //         seq: 1,
                //         key: "ADD2",
                //         label: "เพิ่มปีการศึกษา",
                //         buttonProps: {
                //           onClick: () => {
                //             // setShowModal("ADD")
                //           },
                //         },
                //         type: "ADD2"
                //       }
                //     ]
                //   }
                // }
              ]}
            /> */}

            <section className='w-full mt-4'>
              <TableCustom
                tableMinWidth={1440}
                tableFixedWidth
                customScroll
                page={page}
                pageLimit={pageLimit}
                sortBy={sortBy}
                sortType={sortType}
                headCells={headCells}
                rowCount={totalItems}
                rowsData={data?.map((data: any, i: any) => {
                  return renderData(data, i)
                })}
                onSort={handleRequestSort}
                setPageLimit={(value: number) => setPageLimit(value)}
                setPage={(value: number) => setPage(value)}
              />
            </section>
          </div>
        }
      />

    </div>
  )
}

